// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__NzF4f","emails":"CreateEditClinics_emails__2jG8K","emailTagLabel":"CreateEditClinics_emailTagLabel__Wa2NE"};